import React, { useState } from 'react';

const OneChoicePage = ({
  pageData,
  gameStatus,
  onDecisionSelect,
  displayButton = true,
  editMode = false,
  onEditDecision,
  onAddDecision,
}) => {
  const [selectedDecision, setSelectedDecision] = useState(null); // État pour suivre la décision sélectionnée
  const [updatedScores, setUpdatedScores] = useState({}); // État pour la modification en directe de score

  const listIndicators = pageData.content.list_additional_indicators || [];
  console.log(listIndicators)

  // Préparer les données à retourner
  const prepareReturnData = () => {

    return {
      page_id: pageData._id,
      page_type: pageData.type,
      page_general_consequence: pageData.page_general_consequence,
      round: pageData.round,
      content: {
        decision_list: pageData.content.list_decisions.map((decision) => ({
          ...decision, taken: selectedDecision ? selectedDecision._id === decision._id : false,
        })),
        updated_score : updatedScores
      }
    };
  };

  const handleDecisionClick = (decision) => {
    if (editMode) return; // en édition, le clic sur la carte ne sélectionne pas — seul le crayon agit
    if (!displayButton) return; // partie terminée : plus rien à valider, cocher une case ne serait qu'un leurre
    setSelectedDecision(decision); // Met à jour la décision sélectionnée
  };

  const handleValidation = () => {
    if (selectedDecision) {
      const preparedData = prepareReturnData();
      console.log(preparedData)
      onDecisionSelect(preparedData); // Envoie les données transformées au parent
    } else {
      alert("Veuillez sélectionner une option avant de valider.");
    }
  };

  return (
    <div className="page-general-container">
      <div className='page-general-background-color'></div>

      <div className='page-general-background-hero' style={{ backgroundImage: `url(/img/bgrille-m.svg)` }}>
          <div className='page-general-background-image' style={{ backgroundImage: `url(${pageData.content.background_image_url})` }}></div>
      </div>
      <div className='page-main-content'>
        <h1 className="one-choice-title">{pageData.title}</h1>
        <p className="one-choice-description">{pageData.description}</p>
        <div className="one-choice-list">
          {pageData.content.list_decisions.map((decision, index) => (
            <div
              key={index}
              className={`one-choice-decision ${
                selectedDecision?._id === decision._id ? 'selected' : ''
              } ${editMode ? 'builder-editable-card' : ''}`}
              onClick={() => handleDecisionClick(decision)}
              style={{
                backgroundImage: `url(${decision.image_url})`
              }}
            >
              {editMode && (
                <button
                  className="builder-edit-fab builder-edit-fab-card"
                  onClick={(e) => { e.stopPropagation(); onEditDecision(decision._id); }}
                  title="Modifier cette décision"
                >✏️</button>
              )}
              <div className='one-choice-decision-background'>
                <div className="one-choice-decision-details">
                  <h2 className="one-choice-decision-title">{decision.title}</h2>
                  {(listIndicators.length > 0) && (
                    <div className='one-choice-indicator-list-container'>            
                      { listIndicators.map((indicator) => {
                        const impactData = decision.score[indicator];
                        if (!impactData) return null; // Si l'indicateur n'est pas affecté, on ne l'affiche pas

                        const impact = impactData.impact;
                        const iconUrl = gameStatus.score_dic[indicator]?.icon || '/default-icon.png'; // Icône de l'indicateur
                        const nameIndicator = gameStatus.score_dic[indicator]?.name || indicator;
                        const arrowIcon = impact > 0 ? ("https://res.cloudinary.com/dc1felxem/image/upload/v1741168463/fleche-vers-le-haut_vefvpd.png"):(
                          "https://res.cloudinary.com/dc1felxem/image/upload/v1741168460/fleche-vers-le-bas_1_rltipu.png")
                        const colorIndicator = impact < 0 ? ("#ffcdcd"):("#cdffe4")
                      if (impact === 0) return null;                
                      return (
                        <div className="one-choice-indicator-container" style={{backgroundColor:colorIndicator}} key={indicator} >
                          <div className='one-choice-indicator-title'>{nameIndicator}</div>
                          <img className="mosaic-decision-indicator-icon" src={iconUrl} alt={indicator} />
                          <img className="mosaic-decision-indicator-icon" src={arrowIcon} alt={indicator} />
                          <span className="tooltip">{nameIndicator}</span>
                        </div>
                      );
                      })}
                  </div>)}
                </div>
              </div>

            </div>
          ))}
          {editMode && (
            <div className="one-choice-decision builder-add-card" onClick={onAddDecision} title="Ajouter une décision">
              <span className="builder-add-card-plus">+</span>
              <span>Ajouter une décision</span>
            </div>
          )}
        </div>
        {!editMode && displayButton && (
          <button className="blue-button" onClick={handleValidation}>
            Valider
          </button>
        )}
      </div>
    </div>
  );
};

export default OneChoicePage;
